/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import signInGoogle from './sign-in-google.gif'

export default ({ alt }): React.ReactElement => <img width="253px" src={signInGoogle} alt={alt} />
